import { FC, PropsWithChildren, useCallback, useEffect, useMemo, useState } from "react"
import styles from '../style.module.less'
import { Col, Row } from "antd"

type Menu = {
  hmid: string
  name: string
  icon: string
  children?: Menu[]
  deep: number
}

type PropType = FC<PropsWithChildren<{
  data: Menu
  onChange: (menu) => void
}>>

const SingleMenu: PropType = ({data, onChange}) => {

  const handleMenu = useCallback(() => {
    onChange(data)
  }, [data, onChange])

  return (
    <Col span={6}>
      <div className={`${styles['menu-item']} bg-white radius-6 m-6`} onClick={handleMenu}>
        <img src={data.icon} alt="" />
        <div>{data.name}</div>
      </div>
    </Col>
  )
}

const ComplexMenu: PropType = ({data, onChange}) => {
  const [active, setActive] = useState('')

  const subMenus = useMemo(() => {
    if(data.deep > 2) {
      const target = data.children.find(c => c.hmid === active)
      return target ? target.children : []
    }
    return data.children || []
  }, [data, active])

  // 选择二级菜单
  const handleSubMenu = useCallback((menu) => {
    if(menu.deep > 1) {
      setActive(menu.hmid)
    } else {
      onChange(menu)
    }
  }, [onChange])

  // 默认激活
  useEffect(() => {
    if(data.deep > 2 && data.children && data.children[0]) {
      setActive(data.children[0].hmid)
    }
  }, [data])

  return (
    <div className={`${styles['menu-group']} bg-white radius-6 mlr-6 mtb-8 w-full`}>
      <div className="font-700 mb-4 plr-14 pt-14">{data.name}</div>
      {
        data.deep === 3 && (
          <div className="border-bottom mlr-14 pb-8">
            <Row gutter={12}>
              {
                data.children.map(c => <Col key={c.hmid}>
                  <div onClick={() => handleSubMenu(c)} className={`${styles['menu-sub-item']} ${active === c.hmid ? styles.active : ''} mtb-6`}>{c.name}</div>
                </Col>)
              }
            </Row>
          </div>
        )
      }
      <div className="ptb-6">
        <Row gutter={12}>
          {
            subMenus.map(m => <SingleMenu onChange={onChange} data={m} key={m.hmid} />)
          }
        </Row>
      </div>
    </div>
  )
}

const MenuBlock: PropType = ({data, onChange}) => {
  return data.deep > 1 ? <ComplexMenu onChange={onChange} data={data} /> : <SingleMenu onChange={onChange} data={data} />
}

export default MenuBlock
